module.exports = __webpack_public_path__ + "img/960x480.b79eafe5.svg";